import styled from 'styled-components';

const SideMenuHolder = styled.div`
   .side-menu {
		position: absolute;
		top: 90px;
		min-width: 320px;
		border-top: 2px solid rgba(25,25,25,.2);
		background: url(/static-assets/theme/svg/bottom-decoration.svg) no-repeat;
		background-position: center bottom 1%;
		background-size: 97%;
		background-color: white;	
		z-index: 1;
		padding: 5px;
		font-family: "Quicksand", sans-serif;
		transition: left 0.26s ease;

		&__placeholder {
			background-color: white;
			height: 91px;
			margin-top: -20px;
			margin-left: -5px;
			width: 100%;
			position: absolute;
			top: -73px;
			text-align: center;
			line-height: 125px;
			color: #726b55;
			font-size: 12px;
			font-weight: 700;
		}
		&.expand {
			left: 0px;
			transition: left 0.26s ease;
		}
		&.collapse {  
			left: -400px;
			transition: left 0.26s ease;
		}
		a {
			color: #3c4044;
			text-decoration: none;
			display: block;
			padding: 11.5px 5rem 0.68rem 11.5px;
			font-weight: 700;
			border-radius: 2em;

			img {
				filter: invert(100%) sepia(84%) saturate(1553%) hue-rotate(175deg) brightness(73%) contrast(92%);
				width: 20px;
				vertical-align: middle;
			}

			&:hover {
				color: white;
				background: url(/static-assets/theme/svg/right-decoration.svg) no-repeat;
				background-position: 101% 38%;
				background-color: #35414b;
				background-size: 15%;
			}
			&:last-of-type{ 
				//margin-bottom: 100px;
			}
		}
		.social__container {
			max-width: 100%;
			height: 50px;
			margin-bottom: 52px;
			margin-top: 35px;
			margin-left: 15px;

			.social__icon {
				padding: 0;
				font-weight: 100;
				width: 18px;
				height: 18px;
				display: inline-block;
				margin: 0 20px 0 0;
				filter: invert(48%) sepia(3%) saturate(3425%) hue-rotate(17deg) brightness(94%) contrast(86%);		
				&:hover {
					filter: invert(45%) sepia(30%) saturate(306%) hue-rotate(164deg) brightness(91%) contrast(91%);
					background: none;
				}
			}
		}
    }

`;

export default SideMenuHolder;